import React from 'react';
import { Alert } from '../../components';
import { useI18n } from '@whizz/react-i18n';
import CluedoSearch from '../../assets/Cluedo-Nudges-Teachers-Magnify.svg';

const NoData = ( { alert = false }: { alert?: boolean }) => {

  const { translate } = useI18n();
  if (alert) {
    return (
      <Alert
        show
        type={'info'}
        disableIcon
        invert
        className={'mb-lg whitespace-pre-wrap'}
      >
        <div className={'flex items-center'}>
          <img src={CluedoSearch} />
          {translate('global.NO_DATA')}
        </div>
      </Alert>
    );
  }
  return (
    <div className={'my-md flex justify-center items-center'}>
      <img src={CluedoSearch} />
      <p className={'text-xl font-bold'}>{translate('global.CHARTS.NO_DATA')}</p>
    </div>
  );
};

export default NoData;
